var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('PollScene',{attrs:{"id":"scene"}}),_c('PollCompetition',{attrs:{"id":"competition"}}),_c('PollArticles',{attrs:{"id":"articles"}}),_c('TheComments',{attrs:{"url":_vm.projectUrl}}),_c('TheFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }